
package content

import BaseLayoutStyles
import javaScriptImport.showInCanvas
import javaScriptImport.useMount
import kotlinx.html.id
import react.RBuilder
import react.dom.br
import styled.css
import styled.styledDiv
import styled.styledH1


fun RBuilder.welcomeContent() {
    try {
        styledDiv {
            css {
                +BaseLayoutStyles.articleHeight
                +BaseLayoutStyles.fullWidth
                +BaseLayoutStyles.alignSelfCenter
                +BaseLayoutStyles.noMarginNoPaddingNoBorders
//                +BaseLayoutStyles.solidBorder1px
            }
            attrs.id = "welcomeDiv"
        }
        useMount( {
            showInCanvas()
        })

    } catch (e: Throwable) {
        console.error(e)
        styledH1 {
            css {
                +BaseLayoutStyles.articleHeight
                +BaseLayoutStyles.fullWidth
                +BaseLayoutStyles.alignSelfCenter
                +BaseLayoutStyles.paddingToCenterWelcomeVertically
//                +BaseLayoutStyles.solidBorder1px
            }
            +"Willkommen"
            br {}
            +"bei der"
            br {}
            +"Nusquam GmbH"
            br {}
            +e.toString()
        }
    }
}




